<template>
  <div class="my-setup">
    <div v-if='showPhone'>
      <p class="edit-title">绑定新手机号</p>
      <el-form :label-position="labelPosition" label-width="80px" :model="passInfo" style="width:456px">
          <el-form-item label="请输入新手机号：">
            <div class="form-list">
              <el-input v-model="passInfo.phone"></el-input>
              <el-button
                plain
                size="mini"
                @click="getCode"
                :disabled="disable"
              >{{ btntxt }}</el-button>
            </div>
          </el-form-item>
          <el-form-item label="验证码">
            <div class="form-list">
              <el-input v-model="passInfo.code"></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="showPhone = false" size="small">取消</el-button>
            <el-button type="primary" @click="savePhone" size="small">保存</el-button>
          </el-form-item>
        </el-form>
    </div>
    <div v-else-if="showPass">
      <p class="edit-title">修改密码</p>
      <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" :rules="rules" ref="formLabelAlign">
          <el-form-item label="旧密码：" prop="oldpassword">
            <div class="form-list">
              <el-input v-model="formLabelAlign.oldpassword"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="新密码：" prop="password">
            <div class="form-list">
              <el-input v-model="formLabelAlign.password"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="再次确认新密码：" prop="confirmpassword">
            <div class="form-list">
              <el-input v-model="formLabelAlign.confirmpassword"></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showPass = false" size="small">取消</el-button>
            <el-button type="primary" @click="editPassword('formLabelAlign')" size="small">保存</el-button>
          </el-form-item>
        </el-form>
    </div>
    <div v-else class="passDiv">
      <div class="upLoad">
        <div class="headImg">
          <img :src="userInfo.avatar" alt="">
        </div>
        <el-upload
          class="upload-demo"
          ref="uploadRef"
          :action="uphead"
          :headers="uploadHeaders"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <div class="upHead">
            <el-button style="margin:0 20px">上传头像</el-button>
            <span slot="tip" class="el-upload__tip">仅支持jpg、gif、png、jpeg、bem格式，文件大小4MB</span>
          </div>
        </el-upload>
      </div>
      <div style="width:456px">
        <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
          <el-form-item label="姓名：">
            <div class="form-list">
              <el-input v-model="userInfo.username" :disabled="true"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="手机号：">
            <div class="form-list">
              <el-input v-model="userInfo.phone" :disabled="true"></el-input>
              <p @click="edit('phone')">去修改<i class="el-icon-arrow-right"></i></p>
            </div>
          </el-form-item>
          <el-form-item label="密码：">
            <div class="form-list">
              <el-input value ="123456789" type='password' :disabled="true"></el-input>
              <p @click="edit('password')">去修改<i class="el-icon-arrow-right"></i></p>
            </div>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="submitForm('formLabelAlign')">保存</el-button>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, } from 'vuex'
import api from '@/api/personApi'
import Vue from 'vue'
import {ACCESS_SECRET, ACCESS_TOKEN} from '@/store/mutation-types'
export default {
    data() {
      // 校验
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.formLabelAlign.confirmpassword !== '') {
            this.$refs.formLabelAlign.validateField('confirmpassword');
          }
          callback();
        }
      };
      let validatePass1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入旧密码'));
        }else{
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.formLabelAlign.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };

      return {
        labelPosition: 'top',
        passInfo:{
          phone: '',
          code: '',
        },
        formLabelAlign: {
          username: '',
          oldpassword: '',
          password: '',
          confirmpassword:''
        },
        showPhone:false,
        showPass:false,
        // 上传
        uphead:api.upload(),
        uploadHeaders:{
          ow_token: Vue.ls.get(ACCESS_TOKEN),
          ow_secret: Vue.ls.get(ACCESS_SECRET)
        },
        // 修改手机号
        btntxt: '获取验证码',
        isable: false,
        time: 60,
        disable:false,
        rules: {
          password: [
            { validator: validatePass, trigger: 'blur' }
          ],
          confirmpassword: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          oldpassword:[
            { validator: validatePass1, trigger: 'blur' }
          ]
        }

      }
    },
    mounted(){
      // console.log(this.user,'=====================用户信息')
    },
    computed:{
      ...mapState(["user"]),
      userInfo(){
        console.log(this.user.info)
        return this.user.info
      },
    },
    methods: {
      handleAvatarSuccess(res, file) {
        // console.log(res, file,'上传成功')
        if (res.success) {
          api.updateRealname({id:this.userInfo.id,avatar:res.result.url}).then(res1 => {
            if(res1.success){
              this.$store.commit('setHeadImg',res.result.url)
              this.$message.success(res1.message)
            }else{
              this.$message.error(res1.message);
            }
          }).catch(err => {
            console.log(err)
          })
        }else{
          this.$message.error(res.message);
        }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
        const fileType = ['jpg','gif','png','jpeg','bem']
        const isLt2M = file.size / 1024 / 1024 < 4;
        if (fileType.indexOf(fileSuffix) === -1) {
          this.$message.error("上传文件只能是'jpg'、'gif'、'png'、'jpeg'、'bem'格式");
          return false;
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 4MB!');
          return false;
        }
      },
      // 修改密码
      editPassword(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              ...this.formLabelAlign,
              username:this.userInfo.username
            }
            api.editPassword(params).then(res => {
              if(res.success){
                this.$message.success(res.message)
                this.showPass = false
              }else{
                this.$message.error(res.message)
              }
            }).catch(err => {
              console.log(err)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      edit(type){
        if (type == 'phone') {
          this.showPhone = true
          this.showPass = false
        }else {
          this.showPass = true
          this.showPhone = false
        }
      },
      // 获取验证码
      getCode () {
        let vm = this
        let pattern = /^1[3456789]\d{9}$/
        if (pattern.test(this.passInfo.phone)) {
          let params = {
            phone: this.passInfo.phone
          }
          api
            .sendCaptcha(params)
            .then((res) => {
              if(res.success){
                vm.$message.success('验证码发送成功')
                this.timer()
              }else{
                vm.$message.error(res.message)
              }
              
            })
            .catch((err) => {
              vm.$message.error(err.message)
              // console.log(err)
            })
        } else {
          vm.$message.error('请填写正确的手机号')
        }
      },
      timer () {
        if (this.time > 0) {
          this.disable = true
          this.time--
          this.btntxt = this.time + '秒后可重新发送'
          setTimeout(this.timer, 1000)
        } else {
          this.time = 0
          this.btntxt = '发送验证码'
          this.disable = false
        }
      },
      // 修改手机号
      savePhone(){
        let params = {
          ...this.passInfo,
          id:this.userInfo.id
        }
        api.editPhone(params).then(res => {
          if(res.success){
            this.$message.success(res.message)
            this.$store.commit('setUserPhone',this.passInfo.phone)
            this.showPhone = false
          }else{
            this.$message.error(res.message)
          }
          console.log(res)
        }).catch(err => {
          console.log(err)
        })
      }
    }
}
</script>

<style>
.form-list .el-input{
  width: 360px!important;
}
</style>
<style lang="less" scoped>
.my-setup{
  background: #fff;
  padding: 20px;
}
.upHead{
  display: flex;
}
.upLoad{
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  margin-bottom: 30px;
}
.headImg{
  width: 80px;
  height: 80px;
  border-radius: 50%;
  img{
    width: 100%;
    border-radius: 50%;
  }
}
.form-list{
  display: flex;
  justify-content: space-between;

  p{
    white-space: nowrap;
    color: #999999;
    cursor: pointer;
  }
}
.edit-title{
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  margin-bottom: 20px;
}
</style>